<div
  class="sidenav-mobile-shell"
  #mobileShell
  [class.is-open]="isSmallScreen() && sidenavOpen()"
>
  @if (isSmallScreen() && sidenavOpen()) {
    <button
      type="button"
      class="sidenav-backdrop"
      [attr.aria-label]="'company-tool.sidenav.close-menu' | transloco"
      (click)="closeSidenav()"
    ></button>
  }
  <div class="sidenav" [class.collapsed]="isSidenavCollapsed()" #sidenav>
    <div class="logo" [routerLink]="['dashboard']">
      @switch (themingService.theme) {
        @case ('light') {
          @if (sidenavOpen()) {
            <img
              src="./assets/img/logos/titled/dark_titled_dark.png"
              alt="catch logo"
            />
          } @else {
            <img src="./assets/img/logos/solid/dark.png" alt="catch logo" />
          }
        }
        @case ('dark') {
          @if (sidenavOpen()) {
            <img
              src="./assets/img/logos/titled/white_titled_white.png"
              alt="catch logo"
            />
          } @else {
            <img src="./assets/img/logos/solid/white.png" alt="catch logo" />
          }
        }
      }
      @if (false) {
        <app-button
          (click)="$event.stopPropagation(); toggleSidenav()"
          variant="ghost"
          [iconStart]="fontawesomeService.light.sidebar"
        ></app-button>
      }
    </div>
    <div class="search">
      <div class="row">
        <div class="col-12 form-group icon-start m-0 cmdk-search">
          <fa-icon [icon]="fontawesomeService.light.search"></fa-icon>
          <input
            type="text"
            class="form-control auto-height"
            placeholder="Suche"
            readonly
            aria-haspopup="dialog"
            (mousedown)="openCmdkFromSidenav($event)"
            (keydown.enter)="openCmdkFromSidenav($event)"
            (keydown.space)="openCmdkFromSidenav($event)"
          />
          @if (sidenavOpen()) {
            <app-kbd
              class="cmdk-search__kbd"
              [keys]="cmdkKeys()"
              [ariaLabelOverride]="cmdkAriaLabel()"
            ></app-kbd>
          }
        </div>
      </div>
    </div>
    <div class="menus">
      @switch (sidenavService.menuState) {
        @case ('main') {
          <ul class="menu-list main" [@menuChange]="sidenavService.menuState">
            @if (isAdmin()) {
              <ng-container
                *ngTemplateOutlet="
                  navLink;
                  context: {
                    routerLink: ['/jobs', 'new'],
                    icon: fontawesomeService.light.plus,
                    text: 'company-tool.sidenav.new-job',
                    class: 'ct-btn ct-btn-primary',
                    tourAnchor: 'sidenav-new-job',
                  }
                "
              ></ng-container>
            }
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/dashboard'],
                  icon: fontawesomeService.light.home,
                  text: 'company-tool.views.dashboard.title.sub-1',
                }
              "
            ></ng-container>
            @if (isAdmin()) {
              <ng-container
                *ngTemplateOutlet="
                  navLink;
                  context: {
                    routerLink: ['/reports'],
                    icon: fontawesomeService.light.chartLine,
                    text: 'company-tool.views.performance-analysis.title.reports',
                  }
                "
              ></ng-container>
            }
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/jobs'],
                  icon: fontawesomeService.light.listAlt,
                  text: 'company-tool.views.jobs.main',
                  tourAnchor: 'sidenav-jobs',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/campaigns'],
                  icon: fontawesomeService.light.chartNetwork,
                  text: 'company-tool.views.campaigns.title.main',
                  adminOnly: true,
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/talents'],
                  icon: fontawesomeService.light.idCard,
                  text: 'company-tool.views.talents.main',
                  adminOnly: true,
                }
              "
            ></ng-container>
          </ul>
        }
        @case ('jobs-new') {
          <ul
            class="menu-list jobs-new"
            [@menuChange]="sidenavService.menuState"
          >
            <ng-container
              *ngTemplateOutlet="mainMenuLink; context: { showDivider: true }"
            ></ng-container>
          </ul>
        }
        @case ('job-steps') {
          <ul
            class="menu-list jobs-details"
            [@menuChange]="sidenavService.menuState"
          >
            <ng-container
              *ngTemplateOutlet="mainMenuLink; context: { showDivider: false }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/jobs'],
                  icon: fontawesomeService.light.listAlt,
                  text: 'company-tool.sidenav.back-to-job-overview',
                  exactPath: true,
                }
              "
            ></ng-container>
            <div class="divider-gradient"></div>
            @if (!sidenavService.isInitiative) {
              <ng-container
                *ngTemplateOutlet="
                  navLink;
                  context: {
                    routerLink: [
                      '/jobs',
                      sidenavService.jobId(),
                      'recommendations',
                    ],
                    icon: fontawesomeService.light.userMagnifyingGlass,
                    text: 'company-tool.views.jobs.recommendations.title',
                    exactPath: true,
                    additionalContent: recommendationsCounter,
                  }
                "
              ></ng-container>
              <ng-template #recommendationsCounter>
                @if (
                  sidenavService.recommendationsCountLabel();
                  as countLabel
                ) {
                  <ct-lib-tag class="ms-auto counter-indicator">{{
                    countLabel
                  }}</ct-lib-tag>
                }
              </ng-template>
              <div class="divider-gradient"></div>
            }
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/jobs', sidenavService.jobId()],
                  text: 'company-tool.sidenav.all-applications',
                  exactPath: true,
                  additionalContent: allApplicationsCounter,
                  tourAnchor: 'to-overview',
                }
              "
            ></ng-container>
            <ng-template #allApplicationsCounter>
              <div class="counter">
                <ct-lib-tag
                  class="ms-auto"
                  [variant]="TagVariant.COUNTER_DEFAULT"
                  >{{
                    sidenavService.allJobStepsApplicationsCount > 0
                      ? sidenavService.allJobStepsApplicationsCount
                      : 0
                  }}</ct-lib-tag
                >
              </div>
            </ng-template>
            @for (jobStep of sidenavService.jobSteps(); track jobStep.id) {
              <li
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="
                  jobStep.role === StepRole.NO_ROLE
                    ? null
                    : ['/jobs', sidenavService.jobId(), 'steps', jobStep.id]
                "
                [class.active]="
                  sidenavService.stepId() === jobStep.id ||
                  sidenavService.applicationStepId() === jobStep.id
                "
                [class.no-permission]="jobStep.role === StepRole.NO_ROLE"
                position="right"
                [tooltip]="
                  sidenavOpen()
                    ? jobStep.role === StepRole.NO_ROLE
                      ? ('company-tool.sidenav.no-permissions' | transloco)
                      : undefined
                    : jobStep.title +
                      (jobStep.role === StepRole.NO_ROLE
                        ? ' (' +
                          ('company-tool.sidenav.no-permissions' | transloco) +
                          ')'
                        : '')
                "
              >
                <p>{{ jobStep.title }}</p>
                <div class="counter">
                  <ct-lib-tag
                    class="ms-auto"
                    [variant]="
                      jobStep.news
                        ? TagVariant.COUNTER
                        : TagVariant.COUNTER_DEFAULT
                    "
                    >{{ jobStep.numOfApplications ?? 0 }}</ct-lib-tag
                  >
                </div>
              </li>
            }
          </ul>
        }
        @case ('search') {
          <ul class="menu-list search" [@menuChange]="sidenavService.menuState">
            <ng-container
              *ngTemplateOutlet="mainMenuLink; context: { showDivider: true }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/search', searchService.lastQuery],
                  icon: fontawesomeService.light.star,
                  text: 'company-tool.views.search.title-best',
                  exactPath: true,
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: [
                    '/search',
                    searchService.lastQuery,
                    'applications',
                  ],
                  icon: fontawesomeService.light.user,
                  text: 'company-tool.views.search.title-applicants',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/search', searchService.lastQuery, 'jobs'],
                  icon: fontawesomeService.light.listAlt,
                  text: 'company-tool.views.search.title-jobs',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/search', searchService.lastQuery, 'functions'],
                  icon: fontawesomeService.light.tv,
                  text: 'company-tool.views.search.title-functions',
                }
              "
            ></ng-container>
          </ul>
        }
        @case ('settings-profile') {
          <ul
            class="menu-list settings-profile"
            [@menuChange]="sidenavService.menuState"
          >
            <ng-container
              *ngTemplateOutlet="mainMenuLink; context: { showDivider: true }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'profile', 'account'],
                  icon: fontawesomeService.light.userAlt,
                  text: 'company-tool.views.settings.profile.account.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'profile', 'security'],
                  icon: fontawesomeService.light.shieldAlt,
                  text: 'company-tool.views.settings.profile.security.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'profile', 'signatures'],
                  icon: fontawesomeService.light.fileSignature,
                  text: 'company-tool.views.settings.profile.signatures.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'profile', 'notifications'],
                  icon: fontawesomeService.light.bell,
                  text: 'company-tool.views.settings.profile.notifications.title.sub',
                }
              "
            ></ng-container>
          </ul>
        }
        @case ('settings-company') {
          <ul
            class="menu-list settings-company"
            [@menuChange]="sidenavService.menuState"
          >
            <ng-container
              *ngTemplateOutlet="mainMenuLink; context: { showDivider: true }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'account'],
                  icon: fontawesomeService.light.building,
                  text: 'company-tool.views.settings.company.account.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'payment'],
                  icon: fontawesomeService.light.creditCard,
                  text: 'company-tool.views.settings.company.payment.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'contracts'],
                  icon: fontawesomeService.light.fileContract,
                  text: 'company-tool.views.settings.company.contracts.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'users'],
                  icon: fontawesomeService.light.userAlt,
                  text: 'company-tool.views.settings.company.users.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'facilities'],
                  icon: fontawesomeService.light.mapMarkerAlt,
                  text: 'company-tool.views.settings.company.facilities.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'jobboard'],
                  icon: fontawesomeService.light.suitcase,
                  text: 'company-tool.views.settings.company.jobboard.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'workflows'],
                  icon: fontawesomeService.light.robot,
                  text: 'company-tool.views.settings.company.workflows.title',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'emails'],
                  icon: fontawesomeService.light.at,
                  text: 'company-tool.views.settings.company.emails.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'process'],
                  icon: fontawesomeService.light.listAlt,
                  text: 'company-tool.views.settings.company.application-process.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'privacy'],
                  icon: fontawesomeService.light.userShield,
                  text: 'company-tool.views.settings.company.privacy.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'integration'],
                  icon: fontawesomeService.light.browser,
                  text: 'company-tool.views.settings.company.integrations.title.sub',
                }
              "
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="
                navLink;
                context: {
                  routerLink: ['/settings', 'company', 'connections'],
                  icon: fontawesomeService.light.link,
                  text: 'company-tool.views.settings.company.connections.title.sub',
                }
              "
            ></ng-container>
          </ul>
        }
        @case ('neutral') {
          <ul class="back" [@menuChange]="sidenavService.menuState">
            <ng-container
              *ngTemplateOutlet="mainMenuLink; context: { showDivider: true }"
            ></ng-container>
          </ul>
        }
      }
    </div>
    <div class="bottom-bar">
      <ul class="menu-list">
        <li
          class="credits-counter"
          [class.loading]="!subscriptionLoaded()"
          (click)="subscriptionLoaded() && creditsPopover.toggle($event)"
        >
          <app-credits-counter
            size="sm"
            [showLabel]="sidenavOpen()"
            [showArrow]="sidenavOpen()"
            [showLegend]="false"
          ></app-credits-counter>
        </li>
        <div class="divider-gradient"></div>
        @if (showDownloads()) {
          <li (click)="downloadsPopover.toggle($event)">
            <fa-icon [icon]="fontawesomeService.light.download"></fa-icon>
            <p>Downloads</p>
            @if (exportsCount() > 0) {
              <ct-lib-tag class="ms-auto" [variant]="TagVariant.COUNTER">{{
                exportsCount()
              }}</ct-lib-tag>
            }
          </li>
        }
        <li (click)="newsPopover.toggle($event)">
          <fa-icon [icon]="fontawesomeService.light.bell"></fa-icon>
          <p>{{ 'company-tool.topnav.notifications.title' | transloco }}</p>
          @if (notificationsUnseen() > 0) {
            <ct-lib-tag class="ms-auto" [variant]="TagVariant.COUNTER">{{
              notificationsUnseen()
            }}</ct-lib-tag>
          }
        </li>
        <li (click)="userPopover.toggle($event)" tourAnchor="sidenav-user">
          @if (showAvatarImage()) {
            <img
              [src]="avatarUrl()!"
              alt="avatar"
              class="avatar"
              (error)="onAvatarImageError()"
            />
          } @else {
            <app-avatar-placeholder
              class="avatar"
              [initials]="getUserInitials()"
            ></app-avatar-placeholder>
          }
          <p>{{ userAccount()?.firstName }} {{ userAccount()?.lastName }}</p>
          <fa-icon [icon]="fontawesomeService.light.ellipsis"></fa-icon>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Credits Popover -->
<p-popover
  [unstyled]="true"
  #creditsPopover
  [appendTo]="popoverAppendTo()"
  [autoZIndex]="!isSmallScreen()"
  [styleClass]="popoverStyleClass()"
>
  <ng-template #content let-dismissCreditsPopover="closeCallback">
    <app-credits-counter-expanded
      [showPaymentLink]="true"
      [closePopover]="dismissCreditsPopover"
    ></app-credits-counter-expanded>
  </ng-template>
</p-popover>

<!-- User Popover -->
<p-popover
  [unstyled]="true"
  #userPopover
  [appendTo]="popoverAppendTo()"
  [autoZIndex]="!isSmallScreen()"
  [styleClass]="popoverStyleClass()"
>
  <ng-template #content let-dismissUserPopover="closeCallback">
    <app-sidenav-user [closePopover]="dismissUserPopover"></app-sidenav-user>
  </ng-template>
</p-popover>

<!-- News Popover -->
<p-popover
  [unstyled]="true"
  #newsPopover
  [appendTo]="popoverAppendTo()"
  [autoZIndex]="!isSmallScreen()"
  [styleClass]="popoverStyleClass()"
>
  <ng-template #content let-dismissNewsPopover="closeCallback">
    <app-sidenav-notifications
      [closePopover]="dismissNewsPopover"
    ></app-sidenav-notifications>
  </ng-template>
</p-popover>

<!-- Downloads Popover -->
<p-popover
  [unstyled]="true"
  #downloadsPopover
  [appendTo]="popoverAppendTo()"
  [autoZIndex]="!isSmallScreen()"
  [styleClass]="popoverStyleClass()"
>
  <ng-template #content>
    <app-sidenav-downloads></app-sidenav-downloads>
  </ng-template>
</p-popover>

<!-- Nav Link Template -->
<ng-template
  #navLink
  let-routerLink="routerLink"
  let-icon="icon"
  let-text="text"
  let-adminOnly="adminOnly"
  let-exactPath="exactPath"
  let-additionalContent="additionalContent"
  let-tourAnchor="tourAnchor"
  let-class="class"
>
  <li
    [routerLink]="routerLink"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: exactPath }"
    position="right"
    [tooltip]="
      adminOnly && !isAdmin()
        ? ('company-tool.sidenav.admin-only' | transloco)
        : sidenavOpen()
          ? undefined
          : (text | transloco)
    "
    [class]="class ?? ''"
    [class.no-permission]="adminOnly && !isAdmin()"
    [tourAnchor]="tourAnchor"
  >
    @if (icon) {
      <fa-icon [icon]="icon"></fa-icon>
    }
    <p>{{ text | transloco }}</p>
    <ng-container *ngTemplateOutlet="additionalContent"></ng-container>
  </li>
</ng-template>

<!-- Main Menu Links Template -->
<ng-template let-showDivider="showDivider" #mainMenuLink>
  <li
    [routerLink]="['/dashboard']"
    position="right"
    [tooltip]="
      sidenavOpen()
        ? undefined
        : ('company-tool.sidenav.back-to-main-menu' | transloco)
    "
  >
    <fa-icon [icon]="fontawesomeService.light.home"></fa-icon>
    <p>{{ 'company-tool.sidenav.back-to-main-menu' | transloco }}</p>
  </li>
  <li (click)="routerService.continueNavigationTarget()" position="right">
    <fa-icon [icon]="fontawesomeService.light.arrowLeft"></fa-icon>
    <p>{{ 'company-tool.sidenav.back' | transloco }}</p>
  </li>
  @if (showDivider) {
    <div class="divider-gradient"></div>
  }
</ng-template>

<app-cmdk></app-cmdk>
